import React, { Component, useRef, useState, useEffect } from 'react';
import {Link} from "react-router-dom";

import NavMenu from './NavMenu';
import { Helmet } from 'react-helmet-async';
import * as utils from './Utils.js'

import blueHydrangea from '../assets/hydrangea_blue.png';
// import greenHydrangea from '../assets/hydrangea_green.png';
// import yellowHydrangea from '../assets/hydrangea_yellow.png';
// import purpleHydrangea from '../assets/hydrangea_purple.png';
// import pinkHydrangea from '../assets/hydrangea_pink.png';
// import greyHydrangea from '../assets/hydrangea_grey.png';

import holding from '../assets/engagement/holding.jpeg';
import jumping from '../assets/engagement/jumping.jpeg';
import log from '../assets/engagement/log.jpeg';
import pebbles from '../assets/engagement/pebbles.jpeg';
import pier from '../assets/engagement/pier.jpeg';
import steps from '../assets/engagement/steps.jpeg';

const Homepage = () => {
  useEffect(() => {
  }, [])

  return (
    <div className='Homepage'>
      <Helmet>
        <title>Chandler & Anna</title>
        <meta
          name="description"
          content="Chandler and Anna's Wedding Website."
        />

        {/* Open Graph (iMessage, Facebook, Slack) */}
        <meta property="og:title" content="Chandler & Anna" />
        <meta
          property="og:description"
          content="Join Chandler and Anna as they celebrate their wedding! Find the schedule, travel info, and things to do in Newport."
        />

        <meta
          property="og:image"
          content="https://chandlerandanna.com/og/home.jpeg"
        />
        <meta property="og:image:width" content="661" />
        <meta property="og:image:height" content="992" />
        <meta property="og:url" content="https://chandlerandanna.com/" />
      </Helmet>

      <div className='wedding-page-blocks'>

        {/* <div className='centered-box wedding-page-block'>
          <div className='wedding-centerpiece'>
            <p className='wedding-page-subtitle'>Wedding Weekend Quick Links</p>
            <div className='homepage-quick-links'>
              <Link to="/transportation" className='homepage-quick-link'>Saturday Transportation</Link>
              <span className='date-asterisk desktop-only'>*</span>
              <Link to="/schedule" className='homepage-quick-link'>Schedule</Link>
              <span className='date-asterisk desktop-only'>*</span>
              <Link to="/hotel-and-travel" className='homepage-quick-link'>Hotel &amp; Travel</Link>
              <span className='date-asterisk desktop-only'>*</span>
              <Link to="/things-to-do" className='homepage-quick-link'>Things To Do</Link>
            </div>
          </div>
        </div> */}

        <div className='centered-box wedding-page-block'>
          <div className='wedding-centerpiece'>
            <p className='wedding-page-subtitle'>Look at pictures from the Wedding Weekend!</p>
            <div className='homepage-quick-links'>
              <Link to="/pictures" className='homepage-quick-link'>See the pictures</Link>
            </div>
          </div>
        </div>

        <div className='centered-box wedding-page-block'>
          <div className='main-wedding-centerpiece'>
            <img src={blueHydrangea} className='hydrangea-img'/>
            <div className='wedding-names-titles'>
              <div className='wedding-names-title'>
                <p className='title navy-blue'>Anna Carol Lowney</p>
              </div>
              <div>
                <p className='title navy-blue'>&</p>
              </div>
              <div className='wedding-names-title'>
                <p className='title navy-blue'>Chandler Charles Crane</p>
              </div>
            </div>
            <img src={blueHydrangea} className='hydrangea-img'/>
          </div>

          <p className='sub-title navy-blue'>Newport, Rhode Island <span className='date-asterisk'>*</span> April 25th, 2026</p>

          {/* <Link to="/rsvp">
          <div className='rsvp-div mobile-only'>
            <p className="navy-blue rsvp-title">RSVP</p>
          </div>
          </Link> */}
        </div>

        <div className='centered-box wedding-page-block wedding-photo-album'>
          <div className='wedding-photo-row'>
            <img src={holding} className='wedding-photo photo-top'/>
            <img src={jumping} className='wedding-photo photo-bottom'/>
            <img src={log} className='wedding-photo photo-top'/>
          </div>
        </div>

        {/* <div className='centered-box wedding-page-block wedding-photo-album'>
          <div className='wedding-photo-row'>
            <img src={pebbles} className='wedding-photo photo-top'/>
            <img src={steps} className='wedding-photo photo-bottom'/>
            <img src={pier} className='wedding-photo photo-top'/>
          </div>
        </div> */}

        {/* <div className='centered-box wedding-page-block wedding-photo-album'>
          <div className='wedding-photo-row'>
            <img src={holding} className='wedding-photo blank-photo'/>
            <img src={steps} className='wedding-photo'/>
            <img src={log} className='wedding-photo blank-photo'/>
          </div>
          <div className='wedding-photo-row'>
            <img src={pebbles} className='wedding-photo'/>
            <img src={jumping} className='wedding-photo blank-photo'/>
            <img src={pier} className='wedding-photo'/>
          </div>
        </div> */}

      </div>

      <div className='centered-box'>
        { utils.displayCheckerboard(20, 42, ['blue', 'ivory']) }
      </div>
    </div>
  );
}

export default Homepage;
